import { BaseError } from "@core/foundation/error";

export class JsonDuplicateError extends BaseError {
  public override readonly name = "JsonDuplicateError";
}
